import React from 'react'

const UserOrders = () => {
  return (
    <div>User Orders</div>
  )
}

export default UserOrders